export default __webpack_public_path__ + "img/11.7c71cf.png";